import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import { Col, FloatingLabel, Form, Row, Spinner } from "react-bootstrap"
import { toast } from "react-toastify"
import * as Yup from "yup"
import CustomSelect from "../../../components/CustomSelect"
import ModalComponent from "../../../components/Modal"
import { admin } from "../../../config/apiEndpoints"
import axiosProvider from "../../../lib/AxiosProvider"
import { handleOnBlur, handleOnchange } from "../../../lib/GlobalMethods"
import { _numberRegex_ } from "../../../lib/Regex"

const AddEditFee = ({
  isUpdate,
  setIsUpdate,
  show,
  fetchData,
  setData,
  handleClose,
}) => {
  const [roleData, setRoleData] = useState([])
  const [loading, setLoading] = useState(false)

  const validationSchema = Yup.object({
    base_fee: Yup.string().required("First Name is required"),
    parking_fee: Yup.string().required("Last Name is required"),
    instant_booking_base_fee: Yup.string().required(
      "Instant Booking Base Fee is required",
    ),
    station_id: Yup.string().when("update", {
      is: false,
      then: () => Yup.object().required("Station is Required"),
      otherwise: () => Yup.string().notRequired(),
    }),
  })

  const handleSubmit = async (values, { resetForm }) => {
    try {
      !isUpdate &&
        (values = {
          ...values,
          station_id: values?.station_id?.value,
        })

      const response = await axiosProvider({
        method: isUpdate ? "PATCH" : "POST",
        endpoint: isUpdate ? admin.updateFee + isUpdate.id : admin.createFee,
        data: values,
      })

      if (response?.data?.code === 201 || response?.data?.code === 200) {
        toast.success(response.data.message)
        setLoading(false)
        isUpdate
          ? setData((prevData) =>
              prevData.map((item) =>
                item.id === isUpdate.id
                  ? {
                      ...item,
                      ...response.data.data,
                    }
                  : item,
              ),
            )
          : fetchData("")
        handleClose()
        setIsUpdate(false)
        resetForm()
      } else {
        setLoading(false)
        throw { message: response?.data?.message }
      }
    } catch (error) {
      setLoading(false)
      toast.error(error.message)
    }
  }

  const formik = useFormik({
    initialValues: isUpdate
      ? {
          station_id: isUpdate?.station?.id,
          base_fee: isUpdate?.base_fee,
          instant_booking_base_fee: isUpdate?.instant_booking_base_fee,
          parking_fee: isUpdate?.parking_fee,
        }
      : {
          update: false,
          station_id: "",
          base_fee: "",
          instant_booking_base_fee: "",
          parking_fee: "",
        },
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  })

  const { errors, values, touched, setFieldValue, resetForm } = formik

  const fetchUnassignedChargingStationData = async () => {
    try {
      const response = await axiosProvider({
        method: "GET",
        endpoint: admin.unassignedFeeChargingStation,
      })
      const data = response?.data?.data?.map(({ id }) => ({
        value: id,
        label: id,
      }))
      setRoleData(data)
    } catch (error) {
      toast.error(error?.message)
    }
  }

  useEffect(() => {
    fetchUnassignedChargingStationData()
  }, [handleClose])

  return (
    <>
      <ModalComponent
        show={show}
        modalsize={"md"}
        backdrop="static"
        animationFade={true}
        onHide={() => {
          handleClose()
          resetForm()
        }}
        loading={loading}
        modeltitle={isUpdate ? "Update Station Fees" : "Create Station Fees"}
        submitname={
          loading ? (
            <Spinner size="sm" animation="border" variant="dark" />
          ) : isUpdate ? (
            "Update"
          ) : (
            "Add"
          )
        }
        btnclosetext="Cancel"
        handleSubmit={formik.handleSubmit}
        children={
          <Form noValidate>
            <Row xs={"auto"}>
              <Col xs={12} className="custom_selectinvalid_bdr mb-3">
                {isUpdate ? (
                  <FloatingLabel
                    controlId="emailAdmin"
                    label={
                      <>
                        Station ID <span className="required_star">*</span>
                      </>
                    }
                    className="mb-3"
                  >
                    <Form.Control
                      autoComplete="false"
                      type="text"
                      name="station_id"
                      placeholder=""
                      disabled={true}
                      className="mb-n1"
                      value={values.station_id}
                    />
                  </FloatingLabel>
                ) : (
                  <>
                    <label>
                      Station<span className="required_star">*</span>
                    </label>
                    <CustomSelect
                      value={values?.station_id}
                      handleSelectChange={(selectedOption) => {
                        setFieldValue("station_id", selectedOption)
                      }}
                      options={roleData}
                      isMulti={false}
                      placeholder={"Select Station"}
                    />
                  </>
                )}

                {touched?.station_id && errors?.station_id && (
                  <p className="invalid_error">{errors.station_id}</p>
                )}
              </Col>

              <Col xs={12}>
                <FloatingLabel
                  controlId="base_fee"
                  label={
                    <>
                      Base Fee <span className="required_star">*</span>
                    </>
                  }
                  className="mb-3"
                >
                  <Form.Control
                    autoComplete="false"
                    type="text"
                    name="base_fee"
                    placeholder=""
                    className="mb-n1"
                    value={values.base_fee}
                    onChange={(e) => handleOnchange(e, _numberRegex_, formik)}
                    onBlur={(e) => handleOnBlur(e, formik)}
                    isInvalid={touched.base_fee && errors.base_fee}
                    isValid={touched.base_fee && !errors.base_fee}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.base_fee}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Col>

              <Col xs={12}>
                <FloatingLabel
                  controlId="instant_booking_base_fee"
                  label={
                    <>
                      Instant Booking Base Fee{" "}
                      <span className="required_star">*</span>
                    </>
                  }
                  className="mb-3"
                >
                  <Form.Control
                    autoComplete="false"
                    type="text"
                    name="instant_booking_base_fee"
                    placeholder=""
                    className="mb-n1"
                    value={values.instant_booking_base_fee}
                    onChange={(e) => handleOnchange(e, _numberRegex_, formik)}
                    onBlur={(e) => handleOnBlur(e, formik)}
                    isInvalid={
                      touched.instant_booking_base_fee &&
                      errors.instant_booking_base_fee
                    }
                    isValid={
                      touched.instant_booking_base_fee &&
                      !errors.instant_booking_base_fee
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.instant_booking_base_fee}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Col>

              <Col xs={12}>
                <FloatingLabel
                  controlId="parking_fee"
                  label={
                    <>
                      Parking Fee <span className="required_star">*</span>
                    </>
                  }
                  className="mb-3"
                >
                  <Form.Control
                    autoComplete="false"
                    type="text"
                    name="parking_fee"
                    placeholder=""
                    className="mb-n1"
                    maxLength={10}
                    value={values.parking_fee}
                    onChange={(e) => handleOnchange(e, _numberRegex_, formik)}
                    onBlur={(e) => handleOnBlur(e, formik)}
                    isInvalid={touched.parking_fee && !!errors.parking_fee}
                    isValid={touched.parking_fee && !errors.parking_fee}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.parking_fee}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Col>
            </Row>
          </Form>
        }
      />
    </>
  )
}

export default AddEditFee
